import moment from 'moment'

export function isIsoDate(value: unknown): value is Date {
  if (value instanceof Date) {
    return true
  }
  if (typeof value !== 'string') {
    return false
  }
  return moment(value, moment.ISO_8601, true).isValid()
}
